<div class="iframe-modal">
  <iframe [src]="safeUrl()" frameborder="0" allow="fullscreen" class="iframe-content"></iframe>
</div>
